import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { APIService } from '../../services/api/api-service';
import * as ProductActions from './products.actions';
import { switchMap, tap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { AppState } from '../app.states';
import { Store } from '@ngrx/store';
import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable()
export class ProductsEffects {
  constructor(
    private actions$: Actions,
    private notification: NzNotificationService,
    private api: APIService,
    private router: Router,
    private readonly store: Store<AppState>,
    private readonly modalService: NzModalService
  ) {}


  getProduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductActions.getProduct),
      switchMap((action) =>
        this.api.getProduct(action.productId).pipe(
          map(res =>
            ProductActions.getProductSuccess({ product: res })
          ),
          catchError(error => {
            this.notification.error(
              'Error Loading Product Details',
              error.message
            );
            return of(ProductActions.getProductFailure(error));
          })
        )
      )
    )
  );


}
